// extracted by mini-css-extract-plugin
export default {"tag":"tag--c681f7f1545ee96f37a9","selected":"selected--c12f35c8396ff01e34ea","unselected":"unselected--d017baa9d4f4e640bd3d","disabled":"disabled--df9f233c733b56beb8f3"};